import React from 'react';
import { Box, Heading, Button, Text } from '@chakra-ui/react';

import { useImaginationRoom } from '@invitato/imagination-room';
import { useLocation } from '@reach/router';
import useLang from '@/hooks/useLang';

import { BG_IG_FILTER } from '@/constants/assets';
import { DEFAULT_BUTTON_PROPS } from '@/constants/colors';
import { ID_INSTAGRAM_SECTION } from '@/constants/identifier';
import { IG_FILTER } from '@/constants';

import txt from './locales';
import { TEXT_PROPS } from '@/constants/default-props';

function InstagramFilter() {
  const { onGetFinalContent } = useImaginationRoom();
  const lang = useLang();
  const location = useLocation();
  const isTemplateURL = location.pathname.includes('/template-');

  const handleClickFilterIG = () => {
    window.open(IG_FILTER, '_blank');
  };

  return (
    <Box bgColor="bgPrimary" name={ID_INSTAGRAM_SECTION}>
      <Box
        width="100%"
        height="280px"
        background={`url(${onGetFinalContent('BG_IG_FILTER', BG_IG_FILTER)})`}
        bgSize="cover"
        bgPosition="center"
        display={'flex'}
        flexDir={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Heading {...TEXT_PROPS.heading} color="alternativeColorText">
          Wedding Filter
        </Heading>
        <Button
          {...DEFAULT_BUTTON_PROPS}
          onClick={handleClickFilterIG}
          fontSize={'18px'}
          padding="16px 30px"
          _hover={{
            opacity: 0.8,
          }}
        >
          {txt.textButton[lang]}
        </Button>
        {isTemplateURL && (
          <Text
            fontStyle="italic"
            fontSize="16px"
            fontWeight="light"
            color="alternativeColorText"
            paddingTop="8px"
          >
            *) Filter Instagram tidak masuk dalam paket
          </Text>
        )}
      </Box>
    </Box>
  );
}

export default InstagramFilter;
